<template>
  <div class="part part_about">
    <div class="title"> 
      <img src="../../static/other/line.png"/>
        <h2>用户协议</h2>
        <h2>USER AGREEMENT</h2>
    </div>    
    <el-row>
      <el-col :xs="24" :sm="24" class="about_left">
        <div class="wrap">

          用户协议

<br>版本生效时间：2025年04月01日
<br>开发者：车迹忆

<br>欢迎使用车迹忆服务（以下简称“本服务”或“本APP”）。本用户协议（以下简称“本协议”）是您（以下简称“用户”或“您”）与车迹忆（以下简称“我们”或“本公司”）之间就使用本APP及相关服务所订立的协议。在使用本APP之前，请仔细阅读并理解本协议的全部内容。如果您不同意本协议的任何条款，请立即停止使用本APP。一旦您使用本APP，即表示您已接受本协议的全部条款。

<br>1. 服务内容
<br>1.1 本APP为您提供优质服务。
<br>
<br>1.2 我们保留随时修改、暂停或终止本服务的权利，且无需事先通知用户。
<br>
<br>2. 用户注册与账户
<br>2.1 部分功能可能需要您注册账户。您必须提供真实、准确、完整的注册信息，并及时更新。
<br>
<br>2.2 您应对您的账户和密码的安全性负责，任何通过您的账户进行的操作均视为您本人的行为。
<br>
<br>2.3 如发现任何未经授权使用您账户的情况，应立即通知我们。
<br>
<br>3. 使用规则
<br>3.1 您同意遵守所有适用的法律法规，并承诺不利用本APP从事以下行为：
<br>
<br>发布、传播违法或侵权内容；
<br>
<br>干扰或破坏本APP的正常运行；
<br>
<br>未经授权访问他人数据；
<br>
<br>其他违反公序良俗或损害他人权益的行为。
<br>
<br>3.2 我们有权对违反本协议的行为采取包括但不限于警告、限制功能、封禁账户等措施。
<br>
<br>4. 隐私保护
<br>4.1 您的隐私权对我们非常重要。我们承诺按照《隐私政策》保护您的个人信息。
<br>
<br>4.2 您可以在隐私政策链接查看完整的隐私政策。
<br>
<br>5. 知识产权
<br>5.1 本APP的所有内容（包括但不限于文字、图形、软件、商标等）均受知识产权法保护。
<br>
<br>5.2 未经我们书面许可，您不得复制、修改、传播或用于任何商业用途。
<br>
<br>6. 免责声明
<br>6.1 本APP按“现状”提供，我们不保证服务不会中断或完全无错误。
<br>
<br>6.2 对于因使用或无法使用本APP导致的任何直接或间接损失，我们不承担法律责任。
<br>
<br>7. 服务变更与终止
<br>7.1 我们保留随时修改或终止本服务的权利，无需对用户或第三方负责。
<br>
<br>7.2 您有权随时停止使用本APP。
<br>
<br>8. 适用法律与争议解决
<br>8.1 本协议的解释与适用均依照中国法律。
<br>
<br>8.2 因本协议引起的任何争议，双方应友好协商解决；协商不成时，提交仲裁机构或法院解决。
<br>
<br>9. 其他条款
<br>9.1 本协议构成您与我们之间的完整协议，取代任何先前协议。
<br>
<br>9.2 如果我们未执行本协议的任何条款，不构成对该条款的放弃。
<br>
<br>9.3 如果本协议的任何条款被认定为无效，不影响其他条款的效力。
<br>
<br>联系我们
<br>如果您对本协议有任何疑问，请联系我们：
<br>
<br>联系：13584055209
<br>
<br>地址：江苏省南京市高淳区古城街道绣花线100号299室
<br>
<br>
        </div>
      </el-col>
    </el-row>
  </div> 

</template>
<script>
    export default {
        name: 'About',
        data () {
            return {
              about: [
                        {
                            title: "用户协议",
                            content: ''

                        }
                    ],
              aboutImg:[
                {
                  img: require('../../static/other/aboutUs.png')
                }
              ]
            }
        }
    }
</script>

<style scoped>
  /* 公共 */
  .part{
    margin: 100px 0 200px 0;
  }
  .title{
    text-align: center;
    margin: 120px 0 50px 0;
    color: #317bcb;
  }
  .about_left{
    padding: 0% 5% 0% 5%;
  }
  .about_left ul{
    list-style: none;
    padding-left: 0;
  }
  .about_left ul li{
    text-decoration: none;
    line-height: 2em;
  }
  .about_left li img{
    margin-right: 10px;
  }
  .about_right img{
    width: 60%;
  }
    /* 屏幕设备适配 max-device-width: 400px */
    @media screen and (max-device-width: 415px) {
      .part{
        margin: 50px 0;
      }
      .title{
        margin: 0;
      }
      .about_left{
        padding: 5% 5% 5% 5%;
      }    
      .about_right img{
        width: 90%!important;
        margin-left: 5%;
      }
    }
</style>